import styled from 'styled-components';

export const PaymentMethodWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 40px 0;
`;
